import React, { useState, useEffect, useContext } from "react";
import "./MembersPassbook.css";
import "./Chitgroup.css";
import axios from "axios";
import Select from "react-select";
import AgentSide from "../agentcompo/AgentSide";
import { AgentContext } from "../context/agentcontext";
import { useNavigate, useLocation } from "react-router-dom";
import Cookies from "js-cookie";
import userimage from "./images/userimage.png"

const Agentpay = () => {
  const usernamedashboard = localStorage.getItem("username");
  const [state, setState] = useState("");
  const [duration, setDuration] = useState("");
  const [transactions, setTransactions] = useState([]);
  const [groupName, setGroupName] = useState("");
  const [data, setData] = useState([]);
  const [error, setError] = useState(null);
  const [userId, setUserId] = useState("");
  const [userdata, setUserData] = useState({});
  const [mobileNo, setmobileNo] = useState([]);
  const [groupNameOptions, setGroupNameOptions] = useState([]); // Options for group name dropdown
  const [selectedGroupName, setSelectedGroupName] = useState(""); //
  const { agentname } = useContext(AgentContext);
  const [user, setuser] = useState({});

  const navigate = useNavigate();
  const location = useLocation();
  const [role, setRole] = useState("");
  const [username, setUsername] = useState("");

  useEffect(() => {
    const token = Cookies.get("token");
    const { state } = location;

    if (token) {
      if (location.pathname !== "/getdata/agent/paymentcollection") {
        navigate("/getdata/agent/paymentcollection");
      }
      return;
    }

    if (!state || !state.username || !state.role) {
      if (location.pathname !== "/agent") {
        navigate("/");
      }
      return;
    }

    setUsername(state.username);
    setRole(state.role);
    console.log(state.username, state.role);
  }, [location, navigate]);

  const handleSearch = async (e) => {
    e.preventDefault();
    if (!selectedGroupName || !duration || !mobileNo) {
      alert("Please fill in all input fields.");
      return;
    }
    try {
      const response = await axios.post(
        "http://localhost:5001/transactions/groupname/user",
        {
          groupName: selectedGroupName,
          duration: duration.trim(),
          mobileNo,
        }
      );
      if (response.data.length === 0) {
        alert("No data available.");
      } else {
        setTransactions(response.data);
      }
      // setTransactions(response.data);
      setError(null);
    } catch (error) {
      console.error(error);
      setError("An error occurred. Please try again.");
    }
  };

  useEffect(() => {
    const fetchnameData = async () => {
      try {
        const response = await axios.get(
          `http://localhost:5001/api/getmemberdetails/afterlogin/${usernamedashboard}`
        );
        setuser({ ...response.data[0] });
      } catch (error) {
        console.error("Error fetching assessment data", error);
      }
    };
    fetchnameData();
  }, [usernamedashboard]);

  const gu_id = user.UserId;
  const loadUserData = async () => {
    const response = await axios.get(
      `http://localhost:5001/api/groupuser/chituser/mobileno/${gu_id}`
    );
    setData(response.data);
  };

  useEffect(() => {
    loadUserData();
  }, [gu_id]); //
  useEffect(() => {
    if (mobileNo) {
      fetchUserData();
    }
  }, [mobileNo]);

  const fetchUserData = async () => {
    try {
      const response = await axios.get(
        `http://localhost:5001/api/user/memberpassbook/${mobileNo}`
      );
      // setGroupName(response.data.group_Name);

      const options = response.data.map((group) => ({
        label: group,
        value: group,
      }));
      // Update dropdown options with group names
      setGroupNameOptions(options);
    } catch (error) {
      console.error("Error fetching group names:", error);
      setGroupNameOptions([]); // Reset dropdown options if an error occurs
    }
    // } catch (error) {
    //   console.error("Error fetching user data:", error);
    //   setGroupName(""); // Reset groupName if error occurs
    // }
  };

  return (
    <div   style={{ display: "flex", overflow:"hidden" }}>
      <div>
        <AgentSide />
        {/* <Userside /> */}
      </div>
      <div className="alluserscss C-ttd">
        <div className="info-23">
          <div className="Resp-byuser-head">
            <div className="dash-heading">
              <h2>Member passbook</h2>
            </div>
            <div className="image">
              <div>
                <img
                src={user.uploadPhoto? `http://localhost:5001/uploads/${user.uploadPhoto}` : userimage}
                  // src={`http://localhost:5001/uploads/${user.uploadPhoto}`}
                  alt=""
                  className="images"
                ></img>
              </div>
              <div>
                <p style={{ margin: "0px" }}>{user.UserName}</p>
                <p style={{ margin: "0px" }}>({user.role})</p>
              </div>
            </div>
          </div>
          <hr></hr>
          <div>
            <form onSubmit={handleSearch}>
              <div
                className="display-full-4"
                style={{ width: "100vh", height:"350px",marginTop: "12px" }}
              >
                <div className="Resp-byuser-hk">
                  <div className="Resp-byuser-display-44">
                    <label>
                      <strong>MobileNo</strong>
                    </label>
                    <Select
                      value={{ label: mobileNo, value: mobileNo }}
                      onChange={(selectedOption) =>
                        setmobileNo(selectedOption.value)
                      }
                      options={data.map((opts) => ({
                        label: opts.user_mobileNo,
                        value: opts.user_mobileNo,
                      }))}
                      className="Resp-byuser-input-44"
                      isSearchable={true}
                    />
                  </div>

                  <div className="Resp-byuser-display-44">
                    <label>
                      <strong>Group Name</strong>
                    </label>
                    <Select
                      value={{
                        label: selectedGroupName,
                        value: selectedGroupName,
                      }}
                      onChange={(selectedOption) =>
                        setSelectedGroupName(selectedOption.value)
                      }
                      options={groupNameOptions}
                      className="Resp-byuser-input-44"
                      isSearchable={true}
                    />
                   
                  </div>

                  <div className="Resp-byuser-display-44">
                    <label>
                      <strong>Duration</strong>
                    </label>
                    <select
                      value={duration}
                      onChange={(e) => setDuration(e.target.value)}
                      className="Resp-byuser-input-44"
                      required
                    >
                      <option value="">Select</option>
                      <option value="3 months">3 months</option>
                      <option value="6 months">6 months</option>
                      <option value="12 months">12 months</option>
                    </select>
                  </div>

                 

                 
                </div>

                <div className="">
                  <button type="submit" className="Resp-byuser-button-10">
                    Search
                  </button>
                </div>
              </div>
            </form>
            {error && <p style={{ color: "red" }}>{error}</p>}
            <div className="bgfs">
              {transactions.length > 0 ? (
                <div className="table-member">
                  <table className="tables-style">
                    <thead>
                      <tr className="Ad-sasq">
                        <th colSpan="14" style={{ textAlign: "center" }}>
                          Transactions
                        </th>
                      </tr>
                      <tr>
                        <th className="tahe" style={{ textAlign: "center", margin: "0px" }}>
                          No.
                        </th>
                        <th className="tahe" style={{ textAlign: "center" }}>Payment ID</th>
                        <th className="tahe" style={{ textAlign: "center" }}>Group ID</th>
                        <th className="tahe" style={{ textAlign: "center" }}>Group Name</th>
                        <th className="tahe" style={{ textAlign: "center" }}>Month</th>
                        <th className="tahe" style={{ textAlign: "center" }}>
                          Installment Number
                        </th>
                        {/* <th style={{ textAlign: "center" }}>Bid Winner</th> */}
                        <th className="tahe" style={{ textAlign: "center" }}>
                          Total Amount to pay
                        </th>
                        <th className="tahe" style={{ textAlign: "center" }}>Amount Paid</th>
                        <th className="tahe" style={{ textAlign: "center" }}>Payment Mode</th>
                        <th className="tahe" style={{ textAlign: "center" }}>Balance</th>
                        <th className="tahe" style={{ textAlign: "center" }}>UserId</th>
                        {/* <th className="tahe" style={{ textAlign: "center" }}>UserName</th> */}
                        <th className="tahe" style={{ textAlign: "center" }}>MobileNo</th>
                        <th className="tahe" style={{ textAlign: "center" }}>Payment Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {transactions.map((transaction, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{transaction.paymentcollect_Id}</td>
                          <td>{transaction.payment_idgroup}</td>
                          <td>{transaction.payment_namegroup}</td>
                          <td>{transaction.payment_month}</td>
                          <td>{transaction.payment_insNum}</td>
                          {/* <td>{transaction.bidwinner}</td> */}
                          <td>{transaction.payment_tap}</td>
                          <td>{transaction.payment_hap}</td>
                          <td>{transaction.payment_Mode}</td>
                          <td>{transaction.payment_Balance}</td>
                          <td>{transaction.payment_userId}</td>
                          {/* <td>{transaction.payment_username}</td> */}
                          <td>{transaction.payment_mobilenum}</td>
                          <td>{transaction.payment_Date}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : null}
              {/* (
               <div>
              <p className="vwq">No Data Available</p>
             
                </div> 
            )} */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Agentpay;
